// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import employees from './data/employees';
import EmployeeCard from './components/EmployeeCard';
import EmployeePage from './pages/EmployeePage';
import Slider from 'react-slick';
import titleImage1 from './data/title1.jpg';
import titleImage2 from './data/title2.jpg';
import titleImage3 from './data/title3.jpg';
import logo from './data/logo.jpg';
import backgroundImage from './data/bg3.jpg';
// Import slick-carousel CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const imageUrls = [
  logo,
  titleImage1,
  titleImage2,
  titleImage3,
];

function HomePage() {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000, 
  };

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`, // ✅ Background Image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <div
        className="nav"
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '20px',
        }}
      >
        <img src={logo} alt="Logo" style={{ marginRight: '15px', width: "50px" }} />
        <h1 style={{ margin: 0 }}>Luna Bloom</h1>
        <div
          className="nav-links"
          style={{ marginLeft: 'auto', display: 'flex', gap: '15px' }}
        >
          <span>ALL</span>
          <span>Markham</span>
          <span>North York</span>
          <span>Scarborough</span>
        </div>
      </div>

      {/* Picture Wall Carousel using react-slick */}
      <div style={{ width: '800px', margin: '0 auto 40px', paddingTop: '150px' }}>
        <Slider {...sliderSettings}>
          {imageUrls.map((url, index) => (
            <div key={index}>
              <img
                src={url}
                alt={`Company ${index + 1}`}
                style={{
                  width: '100%',
                  height: '450px',
                  objectFit: 'cover',
                  borderRadius: '10px',
                }}
              />
            </div>
          ))}
        </Slider>
      </div>

      {/* Line */}
      <div style={{ textAlign: 'center' }}>
        {/* Title above the line */}
        <h2
          style={{
            fontFamily: `'Playfair Display', serif`,
            fontSize: '36px',
            fontWeight: 'normal',
            color: '#cc6699', // Soft romantic pink
            marginBottom: '10px',
          }}
        >
          ✿ Intro ✿
        </h2>

        {/* Separator line */}
        <hr
          style={{
            width: '60%',
            margin: '0 auto',
            border: 'none',
            borderTop: '2px solid #f7c6d9', // Light pastel pink
            opacity: 0.8,
          }}
        />
      </div>



      {/* Introduction Section */}
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <h2>💗 Luna Bloom 💗</h2>
        <p>
          {/* <br />按摩•放松身心即刻享受<br />
          <br />欢迎光临，我们专注于提供专业、舒适的按摩服务，助您快速缓解疲劳，恢复活力。<br />
          <br />专业技师：经验丰富，手法到位，为您精准放松。<br />
          <br />热门项目：中式推拿| 精油SPA | 前列腺保养 | 其他特色项目nuru情趣按摩, 采耳, 耳烛。<br />
          <br />舒心环境：安静整洁| 温馨雅致| 禅意空间，让您彻底放松<br />
          <br />明码实价：价格透明，无隐形消费。<br />
          <br />无论您是工作劳累, 运动恢复, 还是寻求片刻宁静, Luna Bloom都是您的理想选择! 即刻预约，开启您的放松之旅！<br /> */}
          <br />Massage • Instant Relaxation for Body and Mind<br />
          <br />Welcome! We specialize in providing professional and comfortable massage services to help you quickly relieve fatigue and restore vitality.<br />
          <br />Professional Therapists: Experienced and skilled, delivering precise relaxation.<br />
          <br />Popular Services: Traditional Chinese Massage | Essential Oil SPA | Prostate Focused Massage | Other Specialty Treatments including Nuru Sensual Massage, Ear caring & candling.<br />
          <br />Comfortable Environment: Quiet and clean | Cozy and elegant | Zen-inspired space for total relaxation.<br />
          <br />Transparent Pricing: Clear and honest prices, no hidden charges.<br />
          <br />Whether you're tired from work, recovering from exercise, or simply seeking a moment of peace, Luna Bloom is your ideal choice! Book now and begin your journey to relaxation!<br />
          <h2 style={{ fontSize: '40px', color: 'lime' }}>📞 Contact Us 📞</h2>
          <h2 style={{ fontSize: '40px', color: 'lime' }}>437-216-6181</h2>
        </p>
      </div>

      {/* Line */}
      <div style={{ textAlign: 'center' }}>
        {/* Title above the line */}
        <h2
          style={{
            fontFamily: `'Playfair Display', serif`,
            fontSize: '36px',
            fontWeight: 'normal',
            color: '#cc6699', // Soft romantic pink
            marginBottom: '10px',
          }}
        >
          ✿ Models ✿
        </h2>

        {/* Separator line */}
        <hr
          style={{
            width: '60%',
            margin: '0 auto',
            border: 'none',
            borderTop: '2px solid #f7c6d9', // Light pastel pink
            opacity: 0.8,
          }}
        />
      </div>

      {/* Employee Cards Section */}
      <div
        style={{
          padding: '20px',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          justifyContent: 'left',
          gap: '30px',
          height: '1500px',
        }}
      >
        {employees.map((emp) => (
          <div key={emp.id} style={{ flexBasis: '200px', maxWidth: '800px' }}>
            <EmployeeCard employee={emp} />
          </div>
        ))}
      </div>

      {/* Line */}
      <div style={{ textAlign: 'center' }}>
        {/* Title above the line */}
        <h2
          style={{
            fontFamily: `'Playfair Display', serif`,
            fontSize: '36px',
            fontWeight: 'normal',
            color: '#cc6699', // Soft romantic pink
            marginBottom: '10px',
          }}
        >
          ✿ Contact ✿
        </h2>

        {/* Separator line */}
        <hr
          style={{
            width: '60%',
            margin: '0 auto',
            border: 'none',
            borderTop: '2px solid #f7c6d9', // Light pastel pink
            opacity: 0.8,
          }}
        />
      </div>
      {/* Contact Section */}
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <h2 style={{ fontSize: '36px' }}>📞 Contact Us 📞</h2>
        <h2 style={{ fontSize: '36px' }}>437-216-6181</h2>
      </div>

    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/employee/:id" element={<EmployeePage />} />
      </Routes>
    </Router>
  );
}

export default App;
